<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import FormSaveButton from '../../../../app/components/form/SaveButton.vue'
  import FormCancelButton from '../../../../app/components/form/CancelButton.vue'
  import DataService from '../../../services/dataService'
  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import {clone} from 'lodash'
  import {required} from 'vuelidate/lib/validators'

  export default {
    components: {ListHeader, FormSaveButton, FormCancelButton},
    data () {
      return {
        isEdit: false,
        isSubmitted: false,
        isLoadingData: true,
        form: {
          institution_id: '',
          name: '',
          description: ''
        },
        dependencies: {}
      }
    },
    validations: {
      form: {
        institution_id: {required},
        name: {required}
      }
    },
    mounted () {
      this.getDependencies()
      const id = this.$route.params.id || null
      if (id) {
        this.isEdit = true
        restfulService.get('institution_unit', null, id)
          .then(response => {
            this.form = response
            this.isLoadingData = false
          })
          .catch(e => {
            console.log(e)
            this.isLoadingData = false
          })
      } else {
        this.isLoadingData = false
      }
    },
    methods: {
      getDependencies () {
        DataService.get([{domain: 'institution'}]).then((result) => {
          this.dependencies = result
        })
      },
      onSend () {
        this.isSubmitted = true
        const data = clone(this.form)
        restfulService.save('institution_unit', null, null, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.$router.push({name: 'institution_unit.index'})
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">

        <ListHeader title="Campus"/>

        <el-card class="el-card__save_form box-card">
            <div slot="header">
                <span>Dados dos Campus</span>
            </div>
            <el-form ref="form"
                     :model="form"
                     label-width="20%"
                     v-on:submit.prevent="onSend">
                <el-form-item label="Instituição"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.institution_id.$error }">
                    <el-select v-model="form.institution_id"
                               filterable
                               placeholder="Selecione uma instituição"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full"
                               @input="$v.form.institution_id.$touch()">
                        <el-option
                                v-for="item in dependencies.institutions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="el-form-item__error" v-if="$v.form.institution_id.$error">
                        Esse campo é obrigatório
                    </div>
                </el-form-item>
                <el-form-item label="Nome"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.name.$error }">
                    <el-input v-model="form.name"
                              @input="$v.form.name.$touch()"></el-input>
                    <div class="el-form-item__error" v-if="$v.form.name.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item label="Descrição">
                    <el-input v-model="form.description"></el-input>
                </el-form-item>
                <el-form-item>
                    <form-save-button :event-click="onSend"
                                      :is-disabled="isSubmitted || $v.$invalid"
                                      :is-submitted="isSubmitted">
                    </form-save-button>
                    <form-cancel-button route-name="institution_unit.index"/>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>



// WEBPACK FOOTER //
// Form.vue?844ec54a